(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fake-header"]) return;
  try {
    
	let interval = setInterval(() => {
        let headerContainer = document.getElementById('lametric-header');

        if (headerContainer) {
            let header = headerContainer.getElementsByTagName('header');

            if (header && header.length > 0) {
                clearInterval(interval);
                setTimeout(() => {
                    document.getElementsByClassName('fake-header-container')[0].style.opacity = '0';
                }, 1000);
            }
        }
    }, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let burgerMenuButton = document.querySelector('.burger-menu-button');
  let burgerMenuElement = document.querySelector('.burger-menu');
  
  burgerMenuButton.addEventListener('click', function(e) {
    burgerMenuElement.classList.toggle('opened');
  })
  document.addEventListener('scroll', function(e) {
    burgerMenuElement.classList.remove('opened');
  })

  } catch(e) { console.error(e); }
})();
})();
